export default {
    OpenSans: "'OpenSans', sans-serif",
}
